import { alpha } from "@mui/material/styles";
import { gray } from "../themePrimitives";

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      // Ortak özellikler (isteğe bağlı)
      root: ({ theme }) => ({
        borderRadius: 10,
      }),

      // Error Alert Styles
      standardError: ({ theme }) => ({
        backgroundColor: "#fdeded",
        color: "#5f2120",
        border: `1px solid ${alpha("#ef5350", 0.5)}`,
        "& .MuiAlert-icon": {
          color: "#ef5350",
        },
        ...theme.applyStyles("dark", {
          backgroundColor: alpha("#d32f2f", 0.2),
          border: `1px solid ${alpha("#ef5350", 0.5)}`,
          color: "#ffffff",
          "& .MuiAlert-icon": {
            color: "#ffffff",
          },
        }),
      }),

      // Warning Alert Styles
      standardWarning: ({ theme }) => ({
        backgroundColor: "#fff4e5",
        color: "#663c00",
        border: `1px solid ${alpha("#ff9800", 0.5)}`,
        "& .MuiAlert-icon": {
          color: "#ff9800",
        },
        ...theme.applyStyles("dark", {
          backgroundColor: alpha("#ed6c02", 0.2),
          border: `1px solid ${alpha("#ff9800", 0.5)}`,
          color: "#ffffff",
          "& .MuiAlert-icon": {
            color: "#ffffff",
          },
        }),
      }),

      // Info Alert Styles
      standardInfo: ({ theme }) => ({
        backgroundColor: "#e5f6fd",
        color: "#014361",
        border: `1px solid ${alpha("#03a9f4", 0.5)}`,
        "& .MuiAlert-icon": {
          color: "#03a9f4",
        },
        ...theme.applyStyles("dark", {
          backgroundColor: alpha("#0288d1", 0.2),
          border: `1px solid ${alpha("#03a9f4", 0.5)}`,
          color: "#ffffff",
          "& .MuiAlert-icon": {
            color: "#ffffff",
          },
        }),
      }),

      // Success Alert Styles
      standardSuccess: ({ theme }) => ({
        backgroundColor: "#edf7ed",
        color: "#1e4620",
        border: `1px solid ${alpha("#4caf50", 0.5)}`,
        "& .MuiAlert-icon": {
          color: "#4caf50",
        },
        ...theme.applyStyles("dark", {
          backgroundColor: alpha("#2e7d32", 0.2),
          border: `1px solid ${alpha("#4caf50", 0.5)}`,
          color: "#ffffff",
          "& .MuiAlert-icon": {
            color: "#ffffff",
          },
        }),
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          border: "1px solid",
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles("dark", {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
